import { forwardRef, useImperativeHandle } from 'react';
import { QueryableComponent } from '@prenuvo/halo';

import './editor.css';

import { useQuillEditor } from './use-quill-editor.hook';

interface EditorProps extends QueryableComponent {
  'aria-label'?: string;
  className?: string;
  displayAsBullets?: boolean;
  isReadOnly?: boolean;
  onBlur?: (editedText: string, currentText?: string) => void;
  onChange?: (value: string) => void;
  placeholder?: string;
  value?: string;
}

export const Editor = forwardRef(
  (
    {
      'aria-label': ariaLabel,
      className,
      'data-testid': dataTestId,
      displayAsBullets = false,
      isReadOnly = false,
      onBlur,
      onChange,
      placeholder = '',
      value,
    }: EditorProps,
    ref,
  ) => {
    const { blur, editorRef } = useQuillEditor({
      displayAsBullets,
      isReadOnly,
      onBlur,
      onChange,
      placeholder,
      value,
    });

    useImperativeHandle(ref, () => ({
      blur,
    }));

    return (
      <div
        aria-label={ariaLabel}
        className={className}
        data-testid={dataTestId ?? 'editor'}
        ref={editorRef}
      />
    );
  },
);

Editor.displayName = 'Editor';
